(function () {
  var config = window.themeCookiePopupDelay;

  if (!config || !config.enabled) {
    return;
  }

  var root = document.documentElement;
  var delay = Math.max(0, Number(config.delaySeconds) || 0) * 1000;
  var hiddenAttribute = 'data-cookie-popup-delay-hidden';
  var selectors = [
    '#shopify-pc__banner',
    '#shopify-pc__prefs',
    '[id^="shopify-pc__banner"]',
    '[id^="shopify-pc__prefs"]',
    '.shopify-pc__banner',
    '.shopify-pc__prefs',
    '.shopify-pc__banner__dialog',
    '.shopify-pc__prefs__dialog',
    '#shopify-privacy-banner',
    '.shopify-privacy-banner',
    '[data-shopify-privacy-banner]',
    '[data-shopify-cookie-banner]',
    '#onetrust-banner-sdk',
    '#onetrust-consent-sdk',
    '#CybotCookiebotDialog',
    '.cky-consent-container',
    '.cc-window',
    '.cc-banner',
    '.cc_dialog',
    '[data-testid="uc-banner"]',
    '[role="dialog"][aria-label*="cookie" i]',
    '[role="dialog"][aria-label*="privacy" i]'
  ];

  function getCookiePopupElements() {
    return selectors.reduce(function (elements, selector) {
      try {
        document.querySelectorAll(selector).forEach(function (element) {
          if (!elements.includes(element)) {
            elements.push(element);
          }
        });
      } catch (error) {
        // Ignore unsupported selectors in older browsers.
      }

      return elements;
    }, []);
  }

  function hideCookiePopups() {
    if (!root.classList.contains('cookie-popup-delay-active')) {
      return;
    }

    getCookiePopupElements().forEach(function (element) {
      element.setAttribute(hiddenAttribute, 'true');
    });
  }

  function showCookiePopups() {
    root.classList.remove('cookie-popup-delay-active');

    getCookiePopupElements().forEach(function (element) {
      element.removeAttribute(hiddenAttribute);
    });
  }

  hideCookiePopups();

  var observer = new MutationObserver(hideCookiePopups);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(function () {
    observer.disconnect();
    showCookiePopups();
  }, delay);
})();
